// extracted by mini-css-extract-plugin
export default {"container":"App_container__cu9yO","title1":"App_title1__8dOD9","title2":"App_title2__wGvx4"};